export const CREATE_INSPECTION_REQUEST = 'inspection/CREATE_INSPECTION_REQUEST';
export const CREATE_INSPECTION_SUCCESS = 'inspection/CREATE_INSPECTION_SUCCESS';
export const CREATE_INSPECTION_FAILURE = 'inspection/CREATE_INSPECTION_FAILURE';
export const GENERATE_INSPECTION_ID = 'inspection/GENERATE_INSPECTION_ID';

export const READ_INSPECTION_REQUEST = 'inspection/READ_INSPECTION_REQUEST';
export const READ_INSPECTION_SUCCESS = 'inspection/READ_INSPECTION_SUCCESS';
export const READ_INSPECTION_FAILURE = 'inspection/READ_INSPECTION_FAILURE';
export const READ_INSPECTIONS_REQUEST = 'inspection/READ_INSPECTIONS_REQUEST';
export const READ_INSPECTIONS_SUCCESS = 'inspection/READ_INSPECTIONS_SUCCESS';
export const READ_INSPECTIONS_FAILURE = 'inspection/READ_INSPECTIONS_FAILURE';
export const READ_INSPECTION_SCHEMAS_REQUEST =
	'inspection/READ_INSPECTION_SCHEMAS_REQUEST';
export const READ_INSPECTION_SCHEMAS_SUCCESS =
	'inspection/READ_INSPECTION_SCHEMAS_SUCCESS';
export const READ_INSPECTION_SCHEMAS_FAILURE =
	'inspection/READ_INSPECTION_SCHEMAS_FAILURE';
export const READ_FORMDATAS_REQUEST = 'inspection/READ_FORMDATAS_REQUEST';
export const READ_FORMDATAS_SUCCESS = 'inspection/READ_FORMDATAS_SUCCESS';
export const READ_FORMDATAS_FAILURE = 'inspection/READ_FORMDATAS_FAILURE';

export const READ_INSPECTION_TYPES_REQUEST =
	'inspection/READ_INSPECTION_TYPES_REQUEST';
export const READ_INSPECTION_TYPES_SUCCESS =
	'inspection/READ_INSPECTION_TYPES_SUCCESS';
export const READ_INSPECTION_TYPES_FAILURE =
	'inspection/READ_INSPECTION_TYPES_FAILURE';

export const UPDATE_INSPECTION_REQUEST = 'inspection/UPDATE_INSPECTION_REQUEST';
export const UPDATE_INSPECTION_SUCCESS = 'inspection/UPDATE_INSPECTION_SUCCESS';
export const UPDATE_INSPECTION_FAILURE = 'inspection/UPDATE_INSPECTION_FAILURE';
export const UPDATE_GENERATED_INSPECTION =
	'inspection/UPDATE_GENERATED_INSPECTION';

export const DELETE_INSPECTION_REQUEST = 'inspection/DELETE_INSPECTION_REQUEST';
export const DELETE_INSPECTION_SUCCESS = 'inspection/DELETE_INSPECTION_SUCCESS';
export const DELETE_INSPECTION_FAILURE = 'inspection/DELETE_INSPECTION_FAILURE';

export const COPY_INSPECTION_REQUEST = 'inspection/COPY_INSPECTION_REQUEST';
export const COPY_INSPECTION_SUCCESS = 'inspection/COPY_INSPECTION_SUCCESS';
export const COPY_INSPECTION_FAILURE = 'inspection/COPY_INSPECTION_FAILURE';

export const UPLOAD_IMAGE_REQUEST = 'inspection/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'inspection/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAILURE = 'inspection/UPLOAD_IMAGE_FAILURE';

export const UPDATE_INSPECTION_FORM_DATA =
	'inspection/UPDATE_INSPECTION_FORM_DATA';

export const EXPORT_INSPECTION_REQUEST = 'inspection/EXPORT_INSPECTION_REQUEST';
export const EXPORT_INSPECTION_SUCCESS = 'inspection/EXPORT_INSPECTION_SUCCESS';
export const EXPORT_INSPECTION_FAILURE = 'inspection/EXPORT_INSPECTION_FAILURE';

export const SEND_WORKORDER_REQUEST = 'inspection/SEND_WORKORDER_REQUEST';
export const SEND_WORKORDER_SUCCESS = 'inspection/SEND_WORKORDER_SUCCESS';
export const SEND_WORKORDER_FAILURE = 'inspection/SEND_WORKORDER_FAILURE';

export const READ_FILTERS_REQUEST = 'inspection/READ_FILTERS_REQUEST';
export const READ_FILTERS_SUCCESS = 'inspection/READ_FILTERS_SUCCESS';
export const READ_FILTERS_FAILURE = 'inspection/READ_FILTERS_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/inspection/inspection.actionTypes.js